<template>
  <div class="form-dlg">
    <el-dialog :title="isUpdate ? '编辑' : '新增'" :visible.sync="showDlg" width="60%" @open="openForm"
      @closed="closedForm">
      <div class="dialog-content">
        <el-form ref="form" :model="formData" :rules="rules" label-width="120px">
          <el-form-item prop="productName" label="商品名称:">
            <el-input v-model="formData.productName" clearable></el-input>
          </el-form-item>
          <el-form-item prop="mainImage" label="商品主图:">
            <image-upload v-model="formData.mainImage" :limit="1"></image-upload>
          </el-form-item>
          <el-form-item prop="mainImage" label="商品轮播图:">
            <image-upload v-model="formData.detailCarouselImages"></image-upload>
          </el-form-item>
          <el-form-item prop="contentIngredients" label="标志性成分含量:">
            <el-input v-model="formData.contentIngredients"></el-input>
          </el-form-item>
          <el-row :guroup="10">
            <el-col :span="12">
              <el-form-item prop="categoryIds" label="商品类型:">
                <el-cascader v-model="formData.categoryIds" :options="categoryTypes" clearable
                  :props="{ checkStrictly: true }" style="width: 100%;"></el-cascader>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="displayCategoryId" label="商品分类:">
                <el-select v-model="formData.displayCategoryId" placeholder="请选择商品分类" style="width: 100%;">
                  <el-option :label="pItem.name" :value="pItem.display_category_id"
                    v-for="(pItem, pIndex) in categoryList" :key="pIndex" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="isOnShelf" label="是否上架:">
                <el-switch v-model="formData.isOnShelf"></el-switch>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="sort" label="排序权重:">
                <el-input-number v-model="formData.sort" :min="0" :max="10000" :step="1"></el-input-number>
              </el-form-item>
            </el-col>
          </el-row>


          <el-form-item prop="productFormulation" label="产品配料:">
            <el-input v-model="formData.productFormulation" type="textarea"></el-input>
          </el-form-item>
          <el-form-item prop="packagingType" label="产品剂型:">
            <el-input v-model="formData.packagingType" clearable></el-input>
          </el-form-item>
          <el-form-item prop="productSpecifications" label="产品规格:">
            <el-input v-model="formData.productSpecifications" clearable></el-input>
          </el-form-item>
          <el-form-item prop="applicablePopulation" label="适用人群:">
            <el-input v-model="formData.applicablePopulation" clearable></el-input>
          </el-form-item>
          <el-form-item prop="scenarioImg" label="详情1:">
            <image-upload v-model="formData.scenarioImg"></image-upload>
          </el-form-item>
          <el-form-item label="详情2:">
            <image-upload v-model="formData.sellingImg"></image-upload>
          </el-form-item>
          <el-form-item label="详情3:">
            <image-upload v-model="formData.certsImg"></image-upload>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="$emit('change', false)">取 消</el-button>
        <el-button type="primary" :loading="loading" @click="handleSubForm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { addPro, editPro, getProDet } from '@/api'
import ImageUpload from '@/components/image-upload'

export default {
  name: 'form-dlg',
  model: {
    prop: 'value',
    event: 'change',
  },
  components: {
    ImageUpload,
  },
  props: {
    value: Boolean,
    data: Object,
    categoryTypes: Array,
    categoryList: Array,
  },
  data() {
    return {
      loading: false,
      formData: {
        sort: 1,
        mainImage: [],
        scenarioImg: [],
        sellingImg: [],
        certsImg: [],
      },
      rules: {
        productName: [{ required: true, message: '请输入', trigger: 'change' }],
        mainImage: [{ required: true, message: '请选择', trigger: 'change' }],
        productCategoryName: [{ required: true, message: '请选择', trigger: 'change' }],
        categoryThreeId: [{ required: true, message: '请选择', trigger: 'change' }],
        // isOnShelf: [{ required: true, message: '请选择', trigger: 'change' }],
        productFormulation: [{ required: true, message: '请输入', trigger: 'change' }],
        packagingType: [{ required: true, message: '请输入', trigger: 'change' }],
        productSpecifications: [{ required: true, message: '请输入', trigger: 'change' }],
        applicablePopulation: [{ required: true, message: '请输入', trigger: 'change' }],
        scenarioImg: [{ required: true, message: '请选择', trigger: 'change' }],
        // sellingImg: [{ required: true, message: '请选择', trigger: 'change' }],
        // certsImg: [{ required: true, message: '请选择', trigger: 'change' }],
        categoryIds: [{ required: true, message: '请选择', trigger: 'change' }],
      },
    }
  },
  computed: {
    showDlg: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('change', val)
      },
    },

    // 编辑模式
    isUpdate() {
      return this.data && (this.data.id || this.data.id === 0)
    },
  },
  watch: {},
  created() { },
  mounted() { },
  beforeDestroy() { },
  methods: {
    // 确定按钮
    handleSubForm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          const params = {
            ...this.formData,
            detailCarouselImages: this.formData?.detailCarouselImages?.map(item => item.url),
            mainImage: this.formData?.mainImage?.map(item => item.url)?.join(','),
            scenarioImg: this.formData?.scenarioImg?.map(item => item.url),
            sellingImg: this.formData?.sellingImg?.map(item => item.url),
            certsImg: this.formData?.certsImg?.map(item => item.url)?.join(','),
          }
          if (this.isUpdate) {
            this.updFormData(params)
          } else {
            this.addFormData(params)
          }
        }
      })
    },

    // 重置表单
    resetForm() {
      this.$refs.form.resetFields()
      this.formData = {
        sort: 1,
        mainImage: [],
        scenarioImg: [],
        sellingImg: [],
        certsImg: [],
        detailCarouselImages: [],
      }
    },

    // 弹窗打开
    openForm() {
      if (this.isUpdate) {
        this.$nextTick(() => {
          this.getDet()
        })
      }
    },

    // 弹窗关闭动画结束
    closedForm() {
      this.resetForm()
    },

    getDet() {
      getProDet({
        id: this.data.id,
      }).then(res => {
        const data = res || {}

        this.formData = {
          ...data,
          detailCarouselImages: data?.detailCarouselImages?.map(item => ({ url: item })),
          mainImage: data?.mainImage?.split(',')?.map(item => ({ url: item })),
          certsImg: data?.certsImg?.split(',')?.map(item => ({ url: item })),
          sellingImg: data?.sellingImg?.map(item => ({ url: item })),
          scenarioImg: data?.scenarioImg?.map(item => ({ url: item })),
        }
      })
    },

    // 新增
    addFormData(params) {
      this.loading = true
      addPro(params)
        .then(res => {
          this.$message.success('操作成功')
          this.loading = false
          this.$emit('change', false)
          this.$emit('submit-form', res)
        })
        .finally(() => {
          this.loading = false
        })
    },

    // 更新
    updFormData(params) {
      this.loading = true
      editPro({
        ...params,
        id: this.data.id,
      })
        .then(res => {
          this.$message.success('操作成功')
          this.loading = false
          this.$emit('change', false)
          this.$emit('submit-form', res)
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
}
</script>

<style lang="less" scoped>
.form-dlg {
  .dialog-content {
    overflow: auto;
    max-height: 50vh;
  }
}
</style>
